import { render, staticRenderFns } from "./trifle-handling.vue?vue&type=template&id=25452afb&scoped=true&"
import script from "./trifle-handling.vue?vue&type=script&lang=js&"
export * from "./trifle-handling.vue?vue&type=script&lang=js&"
import style0 from "./trifle-handling.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-handling.vue?vue&type=style&index=1&id=25452afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25452afb",
  null
  
)

export default component.exports